import { boxCustomisationSelection } from './box-customisation-selection-admin.hook';
import { cancellation } from './cancellation.hook';
import { coupon } from './coupon.hook';
import { exclusions } from './exclusions.hook';
import { orders } from './orders.hook';
import { subscriptions } from './subscriptions.hook';


export const item = {
    ...boxCustomisationSelection,
    ...cancellation,
    ...coupon,
    ...exclusions,
    ...orders,
    ...subscriptions,
};
